<h2 mat-dialog-title>License Required</h2>
<mat-dialog-content class="mat-typography">
  <h3>{{ data.error | slice:7}}</h3>
</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="space-between">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-raised-button color="primary" cdkFocusInitial (click)="onUpdateLicense()">Update License</button>
</mat-dialog-actions>
